import { apiClient } from '@/api/client';
import type {
  ApiSuccess,
  User,
  Courier,
  CreateUserPayload,
  UpdateUserPayload,
} from '@/types/api';

/**
 * TZ-docs/07-api.md §7.3 — Foydalanuvchilar API (F4 Admin).
 */
export async function getUsers(params?: {
  role?: string;
  bakery_id?: number;
  is_active?: boolean;
  search?: string;
}): Promise<User[]> {
  const res = await apiClient.get<ApiSuccess<User[]>>('/users', { params });
  return res.data.data;
}

export async function getUser(id: number): Promise<User> {
  const res = await apiClient.get<ApiSuccess<User>>(`/users/${id}`);
  return res.data.data;
}

export async function createUser(payload: CreateUserPayload): Promise<User> {
  const res = await apiClient.post<ApiSuccess<User>>('/users', payload);
  return res.data.data;
}

export async function updateUser(id: number, payload: UpdateUserPayload): Promise<User> {
  const res = await apiClient.patch<ApiSuccess<User>>(`/users/${id}`, payload);
  return res.data.data;
}

export async function deleteUser(id: number): Promise<{ message: string }> {
  // Backend `envelope({"message": ...})` qaytaradi — `success` emas.
  const res = await apiClient.delete<ApiSuccess<{ message: string }>>(`/users/${id}`);
  return res.data.data;
}

export async function resetUserPassword(id: number, newPassword?: string): Promise<{ temp_password?: string; new_password?: string; message?: string }> {
  const payload = newPassword ? { new_password: newPassword } : undefined;
  const res = await apiClient.post<ApiSuccess<{ temp_password?: string; new_password?: string; message?: string }>>(
    `/users/${id}/reset-password`,
    payload,
  );
  return res.data.data;
}

export async function toggleUserActive(id: number, isActive?: boolean): Promise<User> {
  const payload = isActive !== undefined ? { is_active: isActive } : {};
  const params = isActive !== undefined ? { is_active: isActive } : undefined;
  const res = await apiClient.patch<ApiSuccess<User>>(
    `/users/${id}/toggle-active`,
    payload,
    { params },
  );
  return res.data.data;
}

export async function getCouriers(): Promise<Courier[]> {
  const res = await apiClient.get<ApiSuccess<Courier[]>>('/users/couriers');
  return res.data.data;
}


// ── Akkountni almashtirish (1-punkt) ────────────────────────────────────────

export interface ImpersonateResult {
  access_token: string;
  expires_in: number;
  user: User;
  impersonator_id: number;
  impersonator_name: string;
}

/**
 * Admin boshqa foydalanuvchi nomidan tizimga kiradi.
 * Backend: `POST /users/{id}/impersonate` — audit jurnaliga yoziladi.
 */
export async function impersonateUser(userId: number): Promise<ImpersonateResult> {
  const res = await apiClient.post<ApiSuccess<ImpersonateResult>>(`/users/${userId}/impersonate`);
  return res.data.data;
}

/** Admin o'z sessiyasiga qaytganini audit jurnaliga yozadi (admin tokeni bilan). */
export async function stopImpersonation(userId: number): Promise<void> {
  await apiClient.post(`/users/${userId}/impersonate/stop`);
}
